module.exports = __webpack_public_path__ + "static/media/template_3.7daa2869.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flyers/template_3.png
// module id = 962
// module chunks = 0